import theme from "@configs/theme";
import { getRandomAvatar } from "@helpers/mocked-helpers";
import { isDev } from "@memorang/constants/urls";
import type { LeaderboardItem } from "@memorang/ui/components/Leaderboard/types";
import type { IconType } from "components/types/icon";

// home
export const mockedHomePageHeaderStats = [
	{
		icon: "brain",
		value: "90%",
		label: "Mastery",
		color: theme().palette.purple.main,
	},

	{
		icon: "check-circle-outline",
		value: "200 items",
		label: "Attempted",
		color: theme().colors.secondary,
	},
	{
		icon: "bullseye-arrow",
		value: "80%",
		label: "Accuracy",
		color: theme().colors.error,
	},
];

// progress

export const mockedPracticeTestSummary = {
	title: "Summary",
	subtitle: "Based on 60 items",
	tooltip: "Based on 60 items",
	data: [
		{
			name: "Mastery",
			list: [
				{
					icon: "speedometer",
					title: "Mastered",
					description: "40 items",
					chipLabel: "85%",
					key: "high",
				},
				{
					icon: "speedometer-medium",
					title: "Almost there",
					description: "10 items",
					chipLabel: "2%",
					key: "medium",
				},
				{
					icon: "speedometer-slow",
					title: "Incorrect",
					description: "10 items",
					chipLabel: "13%",
					key: "low",
				},
			],
		},
		{
			name: "Quick stats",
			list: [
				{
					icon: "checkbox-multiple-outline",
					title: "Completion",
					description: "60 / 60",
					chipLabel: "100%",
				},
				{
					icon: "radar",
					title: "Accuracy",
					description: "60 answer attempts",
					chipLabel: "85%",
				},
				{
					icon: "timer-outline",
					title: "Speed",
					description: "60 answer attempts",
					chipLabel: "5 seconds",
				},
			],
		},
	],
};

// leaderboard
const mockedAvatarUrls: string[] = [
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/nurse-asian-male.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/burglar-asian-female.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/superhero-spiderman-comics.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/muslim-attire-black-male.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/robot-3.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/cowhand-asian-female.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/avatar-steampunk-woman-female-african.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/pharmacist-black-male.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/accountant-black-female.svg",
	"https://memorang-prod-icon.s3.us-east-1.amazonaws.com/avatars/ems-worker-asian-female.svg",
];
const mockedUserLeaderboard = {
	username: "whitehorse0912",
	xp: 25245,
	avatar: getRandomAvatar(mockedAvatarUrls),
	rank: 1,
};

const mockedLeaderboard: Record<string, LeaderboardItem[]> = {
	all_time: [
		{
			username: "whitehorse",
			xp: 25245,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 1,
		},
		{
			username: "apick4064",
			xp: 18333,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 2,
		},
		{
			username: "sdille7",
			xp: 14091,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 3,
		},
		{
			username: "meetdb69",
			xp: 13395,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 4,
		},
		{
			username: "fmendoza1963",
			xp: 12678,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 5,
		},
		{
			username: "royelshad",
			xp: 11688,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 6,
		},
		{
			username: "samanthajo95",
			xp: 10767,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 7,
		},
		{
			username: "kerissa26",
			xp: 10303,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 8,
		},
		{
			username: "lenachen",
			xp: 10071,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 9,
		},
		{
			username: "blynsa14",
			xp: 8907,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 10,
		},
	],
	week: [
		{
			username: "whitehorse0912",
			xp: 25245,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 1,
		},
		{
			username: "apick4064",
			xp: 18333,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 2,
		},
		{
			username: "sdille7",
			xp: 14091,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 3,
		},
		{
			username: "meetdb69",
			xp: 13395,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 4,
		},
		{
			username: "fmendoza1963",
			xp: 12678,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 5,
		},
		{
			username: "royelshad",
			xp: 11688,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 6,
		},
		{
			username: "samanthajo95",
			xp: 10767,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 7,
		},
		{
			username: "kerissa26",
			xp: 10303,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 8,
		},
		{
			username: "lenachen",
			xp: 10071,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 9,
		},
		{
			username: "blynsa14",
			xp: 8907,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 10,
		},
	],
	month: [
		{
			username: "whitehorse0912",
			xp: 25245,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 1,
		},
		{
			username: "apick4064",
			xp: 18333,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 2,
		},
		{
			username: "sdille7",
			xp: 14091,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 3,
		},
		{
			username: "meetdb69",
			xp: 13395,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 4,
		},
		{
			username: "fmendoza1963",
			xp: 12678,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 5,
		},
		{
			username: "royelshad",
			xp: 11688,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 6,
		},
		{
			username: "samanthajo95",
			xp: 10767,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 7,
		},
		{
			username: "kerissa26",
			xp: 10303,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 8,
		},
		{
			username: "lenachen",
			xp: 10071,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 9,
		},
		{
			username: "blynsa14",
			xp: 8907,
			avatar: getRandomAvatar(mockedAvatarUrls),
			rank: 10,
		},
	],
};

// profile
const mockedProfileDetails = {
	headerStats: [
		{
			icon: "shield-star-outline",
			value: "Level 100",
			label: "Rank",
			color: "#1AA251",
		},
		{
			icon: "check-circle-outline",
			value: "1,237 items",
			label: "Answered",
			color: "rgb(16, 96, 164)",
		},
		{
			icon: "medal-outline",
			value: "1,445",
			label: "XP Earned",
		},
	],
	statsTabData: [
		// {
		//   'title': 'Current Exam',
		//   'data': [
		//     {
		//       'icon': 'https://icon.memorang.com/icon/icon_bundle_63.png',
		//       'title': 'National Real Estate Salesperson',
		//       'type': 'exam',
		//     },
		//   ],
		// },
		{
			title: "Study Progress",
			data: [
				{
					title: "November 24, 2023",
					rightText: "22 Days until exam",
					description: "Exam date",
					icon: "calendar",
				},
			],
		},
		{
			title: "Leaderboard",
			data: [
				{
					title: "Level 2,151",
					description: "Rank",
					icon: "medal-outline",
					rightText: "2,151",
				},
				{
					title: "9,966 XP",
					rightText: "2,151",
					description: "all-time",
					icon: "star-four-points-outline",
				},
				{
					title: "360 XP",
					rightText: "23,366",
					description: "this month",
					icon: "calendar-month-outline",
				},
				{
					title: "57 XP",
					rightText: "19,643",
					description: "this week",
					icon: "calendar-week",
				},
			],
		},
	],
};
// report

const mockedSummaryCardData = {
	title: "Practice Questions Complete",
	score: 90,
	numItems: 20,
	maxScore: 20,
	stats: [
		{
			overlineText: "Correct",
			icon: "checkbox-marked-circle-outline",
			value: "18 / 20",
			tooltip: "How many questions you've answered",
		},
		{
			overlineText: "Accuracy",
			icon: "radar",
			value: "90%",
			tooltip: "How many questions you've answered correctly",
		},
		{
			overlineText: "Duration",
			icon: "timer-outline",
			value: "10:09",
			tooltip: "How long you took to complete the test",
		},
		{
			overlineText: "AVG SPEED",
			icon: "timer-outline",
			value: "1.2 secs",
			description: "How long you took to answer each question",
		},
	],
};

const mockedMasteryCardData = {
	title: "Session Mastery",
	subtitle: "Based on 20 items",
	sections: [
		{
			sectionTitle: "Correct",
			items: [
				{
					title: "Mastered",
					count: 12,
					icon: "speedometer" as IconType,
					type: "correct" as const,
					color: "#66bb68",
				},
				{
					title: "Almost There",
					count: 4,
					type: "almostcorrect" as const,
					icon: "speedometer-medium" as IconType,
					color: "#dda53a",
				},
			],
		},
		{
			sectionTitle: "Incorrect",
			items: [
				{
					title: "Needs Work",
					type: "incorrect" as const,
					count: 4,
					icon: "speedometer-slow" as IconType,
					color: "#d66565",
				},
			],
		},
	],
};
const mockedTagProgressData = [
	{
		title: "Topics",
		subtitle: "Based on 20 items across 4 topics",
		tagType: "Topic",
		items: [
			{
				title: "Basic Skills",
				distribution: {
					low: 13,
					none: 15,
					high: 9,
					medium: 15,
				},
				rightText: "10 items",
				tagType: "Topic",
			},
			{
				title: "Advanced Trauma Resuscitation and Airway Management",
				distribution: {
					low: 10,
					none: 12,
					high: 8,
					medium: 14,
				},
				rightText: "10 items",
				tagType: "Topic",
			},
		],
	},
];

export const diagnosticTagIds = {
	readingListening: 1000,
	speakingWriting: 1001,
};
const diagnosticItemIds = {
	[diagnosticTagIds.readingListening]: isDev
		? [30199, 30200, 30201, 30202, 30203, 30353]
		: [13752, 13760, 13761, 13907, 13908, 13909],
	[diagnosticTagIds.speakingWriting]: isDev ? [30577, 30579] : [14097, 14153],
};

const diagnosticItems = [
	{
		icon: "book-open-page-variant-outline" as const,
		id: diagnosticTagIds.readingListening,
		status: "NOT_STARTED",
		title: "Reading & Listening",
		itemIds: diagnosticItemIds[diagnosticTagIds.readingListening],
		numItems: 6,
	},
	{
		icon: "microphone-outline" as const,
		id: diagnosticTagIds.speakingWriting,
		status: "NOT_STARTED",
		title: "Speaking & Writing",
		itemIds: diagnosticItemIds[diagnosticTagIds.speakingWriting],
		numItems: 2,
	},
];
export {
	mockedUserLeaderboard,
	mockedLeaderboard,
	mockedProfileDetails,
	mockedSummaryCardData,
	mockedMasteryCardData,
	mockedTagProgressData,
	diagnosticItems,
};
